import { LinkOptions } from '../../lib/types';

import {
  CONTACT_US,
  QCOM_PRIVACY_AND_SECURITY_URL,
  QCOM_TERMS_OF_USE_URL,
  DESTINATIONS_AUSTRALIA,
  FAQS,
} from '../../lib/config';

export const links: LinkOptions[] = [
  {
    to: CONTACT_US,
    'data-testid': 'contactLink',
    children: 'Contact',
  },
  {
    href: QCOM_PRIVACY_AND_SECURITY_URL,
    'data-testid': 'privacySecurityLink',
    children: 'Privacy & Security',
  },
  {
    href: QCOM_TERMS_OF_USE_URL,
    'data-testid': 'termOfUseLink',
    children: 'Terms of use',
  },
  {
    to: DESTINATIONS_AUSTRALIA,
    'data-testid': 'australianDestinationsLink',
    children: 'Australian destinations',
  },
  {
    to: FAQS,
    'data-testid': 'faqsLink',
    children: 'FAQs',
  },
];
